export function GetMockMilestoneNoteRead() {
  return {
    id: 1,
    caseMilestoneId: 2,
    addedByUserId: 4,
    note: "Test",
    dateAdded: "2022-02-01T11:20:26.136394",
    dateUpdated: "0001-01-01T00:00:00",
    isDeleted: 0,
    dateDeleted: "0001-01-01T00:00:00",
  };
}
